import { Icon } from "semantic-ui-react";

import "components/Notes/NoteEditBtn/NoteEditBtn.scss";
import { APPOINTMENT_NOTE_TYPES } from "models";

import type { CAR_NOTE_TYPE } from "models";

type NoteEditBtnProps = {
  type: APPOINTMENT_NOTE_TYPES | CAR_NOTE_TYPE;
  isCarNote?: boolean;
  onSelectNote?: () => void;
};

type NoteStyle = { backgroundColor: string; iconColor: string };

const NOTE_STYLE_CONFIG: Partial<Record<number, NoteStyle>> = {
  [APPOINTMENT_NOTE_TYPES.WO]: { backgroundColor: "#2D85D033", iconColor: "#4283CA" },
  [APPOINTMENT_NOTE_TYPES.Main]: { backgroundColor: "#FF020233", iconColor: "#DB2828" },
  [APPOINTMENT_NOTE_TYPES.CallCustomer]: { backgroundColor: "#21BA4533", iconColor: "#21BA45" },
  [APPOINTMENT_NOTE_TYPES.Bill]: { backgroundColor: "#21BA4533", iconColor: "#21BA45" },
  [APPOINTMENT_NOTE_TYPES.TempDriver]: { backgroundColor: "rgba(0, 0, 0, 0.2)", iconColor: "#1B1C1D" },
  [APPOINTMENT_NOTE_TYPES.RecurringCar]: { backgroundColor: "rgba(200, 54, 40, 0.2)", iconColor: "#C83628" },
  [APPOINTMENT_NOTE_TYPES.Attachment]: { backgroundColor: "#21A1D033", iconColor: "#4283CA" },
  [APPOINTMENT_NOTE_TYPES.ParkingLocation]: { backgroundColor: "#21A1D033", iconColor: "#4283CA" },
  [APPOINTMENT_NOTE_TYPES.NoDrive]: { backgroundColor: "#FF030133", iconColor: "#FF0301" }
};

const CAR_NOTE_STYLE: NoteStyle = { backgroundColor: "#EA2D6233", iconColor: "#ea2d62" };

export const NoteEditBtn = ({ type, onSelectNote, isCarNote = false }: NoteEditBtnProps) => {
  const style = isCarNote ? CAR_NOTE_STYLE : NOTE_STYLE_CONFIG[type];
  if (!style) return null;

  return (
    <div className="AppointmentNoteEditBtn" style={{ backgroundColor: style.backgroundColor }} onClick={onSelectNote}>
      <Icon className="pen to square" style={{ color: style.iconColor }} />
    </div>
  );
};
